import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer({ isForLogin = false }) {
    return (
        isForLogin ?
            <footer className=" bg-blue-100 text-blue-800 py-4 px-2 rounded-b-3xl">
                <div className="flex flex-wrap justify-center gap-1 text-sm">
                    <a className='text-gray-700'>© {moment(Date.now()).format("YYYY")} <a className='text-blue-700' href='https://cubicleeight.com' target='_blank'>Cubicle Eight</a>. All Rights Reserved</a>
                </div>
            </footer>
            :
            <footer className=" bg-blue-100 text-blue-800 py-3 px-2">
                <div className="flex flex-wrap justify-center gap-4 text-sm">
                    <Link to="/">Home</Link>
                    <Link to="/about">About</Link>
                    <Link to="/contact">Contact</Link>
                    <Link to="/terms">Terms</Link>
                    <Link to="/privacy">Privacy</Link>
                    <a className='hidden sm:block'>|</a>
                    <a className='text-gray-700'>© {moment(Date.now()).format("YYYY")} <a className='text-blue-700' href='https://cubicleeight.com' target='_blank'>Cubicle Eight</a>. All Rights Reserved</a>
                </div>
            </footer>
    )
}
